/* istanbul ignore file */
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Router, Route } from 'framework/routing';
import { ProcessInstanceRouter } from 'domain/gpo/cockpit/instance';
import { ProcessDefinitionRouter } from 'domain/gpo/cockpit/definition';
import { Routes } from 'react-router-dom';
import ProcessAssetsRouter from 'domain/gpo/processAssets/ProcessAssetsRouter';
import TaskConstructorRouter from './taskConstructor/TaskConstructorRouter';
import { Features, featureToggles } from 'infrastructure/featureToggle';

const GPO_PATH = '/processes';

const preparePath = (path: string): string => {
  return path.replace(GPO_PATH, '');
};

const taskConstructorEnabled = Boolean(featureToggles[Features.TASK_CONSTRUCTOR]);

const GpoRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();

  return (
    <Routes>
      <Route path={ProcessInstanceRouter.getRouterPath()} element={<ProcessInstanceRouter />} />
      <Route path={ProcessDefinitionRouter.getRouterPath()} element={<ProcessDefinitionRouter />} />
      {taskConstructorEnabled && (
        <Route path={TaskConstructorRouter.getRouterPath()} element={<TaskConstructorRouter />} />
      )}
      <Route path={preparePath(ProcessAssetsRouter.getRouterPath())} element={<ProcessAssetsRouter />} />
      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

GpoRouter.getRouterPath = () => `${GPO_PATH}/*`;

export default GpoRouter;
